{
  "sections": [
    {
      "section_id": "question",
      "section_display_name": "Question",
      "section_type": "question",
      "checklist": [
        {
          "id": "question_correct_general",
          "display_name": "Is the question content correct and the storyline consistent?",
          "explanation": "https://examdojo.notion.site/Is-the-question-correct-1a8b7b3bb46681c5978bd1996b0f54e6?pvs=73",
          "type": "yes/no",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "question_format_formula",
          "display_name": "Are the formulas formatted correctly?",
          "type": "yes/no",
          "show_extra_text_field": "no_response",
          "explanation": "https://examdojo.notion.site/Is-the-question-formatted-correctly-1a8b7b3bb46681d5923fc428f27f7bb9?pvs=73",
          "pass_condition": "yes_response",
          "in_statuses": [
            "NEEDS_PRESCREENING",
            "NEEDS_EXPERT_PRESCREENING",
            "NEEDS_HUMAN_REVIEW",
            "NEEDS_TIE_BREAK"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_PRESCREENING"],
              "to": "NEEDS_EXPERT_PRESCREENING"
            },
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "NEEDS_PRESCREENING"
            },
            {
              "from": ["NEEDS_EXPERT_PRESCREENING"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "question_format_other",
          "display_name": "Is everything else formatted correctly?",
          "explanation": "https://examdojo.notion.site/Is-the-question-formatted-correctly-1a8b7b3bb46681d5923fc428f27f7bb9?pvs=73",
          "type": "yes/no",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": [
            "NEEDS_PRESCREENING",
            "NEEDS_EXPERT_PRESCREENING",
            "NEEDS_HUMAN_REVIEW",
            "NEEDS_TIE_BREAK"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_PRESCREENING"],
              "to": "NEEDS_EXPERT_PRESCREENING"
            },
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "NEEDS_PRESCREENING"
            },
            {
              "from": ["NEEDS_EXPERT_PRESCREENING"],
              "to": "DELETED"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "markscheme",
      "checklist": [
        {
          "id": "markscheme_correct_math",
          "display_name": "Is the math of the markscheme correct?",
          "explanation": "https://examdojo.notion.site/Is-the-markscheme-correct-and-complete-1a8b7b3bb4668188bf5ed5df489e06e1?pvs=73",
          "type": "yes/no",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "markscheme_solvable_no_calculator",
          "display_name": "Is the markscheme solvable without a calculator?",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Is-it-solvable-without-a-calculator-1a8b7b3bb466813993f4f0f79c615ac3?pvs=73",
          "display": "has_no_calculator",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "markscheme_format_formula",
          "display_name": "Are the formulas formatted correctly?",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Is-the-markscheme-and-content-formatted-correctly-1a8b7b3bb4668145b750ea04e6cffd75?pvs=73",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": [
            "NEEDS_PRESCREENING",
            "NEEDS_EXPERT_PRESCREENING",
            "NEEDS_HUMAN_REVIEW",
            "NEEDS_TIE_BREAK"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "NEEDS_PRESCREENING"
            },
            {
              "from": ["NEEDS_PRESCREENING"],
              "to": "NEEDS_EXPERT_PRESCREENING"
            },
            {
              "from": ["NEEDS_EXPERT_PRESCREENING"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "markscheme_format_other",
          "display_name": "Is everything else formatted correctly?",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Is-the-markscheme-and-content-formatted-correctly-1a8b7b3bb4668145b750ea04e6cffd75?pvs=73",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": [
            "NEEDS_PRESCREENING",
            "NEEDS_EXPERT_PRESCREENING",
            "NEEDS_HUMAN_REVIEW",
            "NEEDS_TIE_BREAK"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "NEEDS_PRESCREENING"
            },
            {
              "from": ["NEEDS_PRESCREENING"],
              "to": "NEEDS_EXPERT_PRESCREENING"
            },
            {
              "from": ["NEEDS_EXPERT_PRESCREENING"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "markscheme_solution_paths",
          "display_name": "Have you checked every single solution path?",
          "display": "has_multiple_solution_paths",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Is-the-markscheme-and-content-formatted-correctly-1a8b7b3bb4668145b750ea04e6cffd75?pvs=73",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "mcq",
      "section_display_name": "Multiple Choice Options",
      "checklist": [
        {
          "id": "mcq_correct_option",
          "display_name": "Is the correct option(s) selected?",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Has-the-structure-of-the-MCQ-been-parsed-correctly-229b7b3bb46680069f4eedf4e7c82e8e",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "mcq_solvable_no_calculator",
          "display_name": "Is the MCQ solvable without a calculator?",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Is-it-solvable-without-a-calculator-1a8b7b3bb466813993f4f0f79c615ac3?pvs=73",
          "display": "has_no_calculator",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "mcq_correct_worked_solution",
          "display_name": "Are all steps of the worked solution mathematically correct?",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Has-the-structure-of-the-MCQ-been-parsed-correctly-229b7b3bb46680069f4eedf4e7c82e8e",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "DELETED"
            }
          ]
        },
        {
          "id": "mcq_correct_worked_solution_format",
          "display_name": "Is the worked solution formatted correctly?",
          "type": "yes/no",
          "explanation": "https://examdojo.notion.site/Has-the-structure-of-the-MCQ-been-parsed-correctly-229b7b3bb46680069f4eedf4e7c82e8e",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "DELETED"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "image",
      "checklist": [
        {
          "id": "image_correct",
          "display_name": "Does the generated image fullfill the requirements?",
          "type": "yes/no",
          "explanation": "missing",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": [
            "NEEDS_IMAGE_REVIEW",
            "NEEDS_EXPERT_IMAGE_REVIEW",
            "NEEDS_HUMAN_REVIEW",
            "NEEDS_TIE_BREAK"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "NEEDS_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_IMAGE_REVIEW", "NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "DELETED"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "table",
      "checklist": [
        {
          "id": "table_generated_correct",
          "display_name": "Does the generated table fullfill the requirements?",
          "type": "yes/no",
          "explanation": "missing",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": [
            "NEEDS_IMAGE_REVIEW",
            "NEEDS_EXPERT_IMAGE_REVIEW",
            "NEEDS_HUMAN_REVIEW",
            "NEEDS_TIE_BREAK"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_HUMAN_REVIEW", "NEEDS_TIE_BREAK"],
              "to": "NEEDS_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_IMAGE_REVIEW"],
              "to": "NEEDS_EXPERT_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "DELETED"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "other",
      "section_display_name": "Other",
      "checklist": [
        {
          "id": "other",
          "display_name": "Are there any other issues?",
          "type": "yes/no",
          "show_extra_text_field": "yes_response",
          "display": "always_visible",
          "pass_condition": "no_response",
          "in_statuses": [
            "NEEDS_PRESCREENING",
            "NEEDS_HUMAN_REVIEW",
            "NEEDS_TIE_BREAK"
          ],
          "rejection_statuses": [
            {
              "from": [
                "NEEDS_EXPERT_PRESCREENING",
                "NEEDS_HUMAN_REVIEW",
                "NEEDS_TIE_BREAK"
              ],
              "to": "DELETED"
            },
            {
              "from": ["NEEDS_PRESCREENING"],
              "to": "NEEDS_EXPERT_PRESCREENING"
            }
          ]
        }
      ]
    }
  ]
}
